import React from 'react'
import Menu from '../component/Menu';
import HeaderCasestudy from '../component/HeaderCasestudy';
import Casestudybody from '../component/Casestudybody26';
import Footer from '../component/Footer'
import { Helmet } from 'react-helmet';

const CaseStudy26 = ({setBlank}) => {
     
    const headings = "<h2 style='display:inline-block;color:#ffffff;margin-right:15px;'> Feasibility study </h2></h4><h4>For A Hotel Development By A Real Estate Development Company</h4>";

  return (
    <>
        <Helmet>
        <title>Feasibility Study For A Hotel Development By A Real Estate Development Company</title>
        <meta property="og:title" content="Feasibility study For A Hotel Development By A Real Estate Development Company" />
        <meta property='og:description' content='Feasibility For A Hotel Development By A Real Estate Development Company'/>
        <meta name='keywords' content=''/>
        </Helmet>

        <Menu setBlank={setBlank}  />
        <HeaderCasestudy class="header-casestudy26" headings={headings} />  
        <Casestudybody />
        <Footer setBlank={setBlank} />
    </>
  )
}

export default CaseStudy26
